import { render, staticRenderFns } from "./support-item.vue?vue&type=template&id=6fa75176"
import script from "./support-item.vue?vue&type=script&lang=js"
export * from "./support-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa75176')) {
      api.createRecord('6fa75176', component.options)
    } else {
      api.reload('6fa75176', component.options)
    }
    module.hot.accept("./support-item.vue?vue&type=template&id=6fa75176", function () {
      api.rerender('6fa75176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/support/components/support-item.vue"
export default component.exports